import {formatStringToFloatDecimalCase} from "src/utils/format-decimal"
import React, {useEffect, useState} from "react"
import PriceService from "src/services/price-service"
import {localeBRDataGridText} from "src/utils/data-grid-local-text"
import PropTypes from "prop-types"
import {dispatchSnackbar} from "../../../../components/SnackBar/snackbar-bus"
import DataGridTable from "../../../../components/Table/data-grid-table"
import {columnsPriceTable} from "./tabela-preco-constants"
import GraficoDateRangeModal from "./Grafico/grafico-date-range-modal"

const TabelaPreco = ({date, loading, setLoading, setExportFileCsv}) => {
    const priceService = new PriceService()
    const [priceList, setPriceList] = useState([])
    const [isChartOpen, setIsChartOpen] = useState(false)
    const [selectedRowData, setSelectedRowData] = useState(null)
    const [chart, setChart] = useState({
        title: "Gráfico de PU",
        xTitle: "Data Referência",
        yTitle: "PU",
        yRightTitle: "%PUPAR",
        data: []
    })
    const [csvData, setCsvData] = useState([])

    useEffect(() => {
        setExportFileCsv(() => async () => {
            return priceService.exportDataToCsv(date)
        })
        loadPrices(date)
    }, [date])

    const handleOpenChart = (rowData) => {
        setSelectedRowData(rowData)
        setIsChartOpen(true)
    }

    const loadPrices = () => {
        if (date === null) return

        setLoading(true)
        priceService.getPricesv2(date, date)
            .then((response) => {
                setLoading(false)
                const {body} = response
                const {data} = body
                const rows = data.map((obj, index) => ({...obj, id: index}))
                setPriceList(rows)
                // console.log(response)
                // setPriceList([])
            }).finally(() => setLoading(false))
    }

    const generateCsvData = (body) => {
        const {PU_MTM, PUPAR, PercentualPUPAR} = body

        // assume que os arrays têm o mesmo length
        const data = PU_MTM.map((item, index) => {
            return {
                DataReferencia: item.DataReferencia,
                CETIP: item.CETIP,
                PU_MTM: formatStringToFloatDecimalCase(item.PU_MTM),
                PUPAR: formatStringToFloatDecimalCase(PUPAR[index].PUPAR),
                PercentualPUPAR: formatStringToFloatDecimalCase(PercentualPUPAR[index].PercentualPUPAR),
            }
        })

        setCsvData(data)
    }

    const loadChartData = (date) => {
        if (!selectedRowData) return

        setLoading(true)
        const cetipList = [selectedRowData.CETIP]

        priceService.generatePriceData(date.firstDate, date.endDate, cetipList)
            .then((response) => {
                setLoading(false)
                const {body} = response
                generateCsvData(body)
                const chartData = priceService.generatePUPARChart(body)

                setChart(prev => ({
                    ...prev,
                    data: chartData
                }))

                console.log(chartData)
            })
            .catch(() => {
                setLoading(false)
                setIsChartOpen(false)
                dispatchSnackbar("Não foi possível carregar os dados, tente novamente", "warning")
            })
    }

    return (
        <>
            <DataGridTable
                rows={priceList}
                columns={columnsPriceTable(date, handleOpenChart)}
                pageSize={25}
                disableRowSelectionOnClick
                sortingOrder={['asc', 'desc']}
                localeText={localeBRDataGridText}
            />
            <GraficoDateRangeModal
                open={isChartOpen}
                onClose={() => setIsChartOpen(false)}
                title={`Gráfico de PUPAR - ${selectedRowData?.CETIP || ''}`}
                loadChartData={loadChartData}
                loading={loading}
                chartData={chart}
                csvData={csvData}
            />
        </>
    )
}

TabelaPreco.propTypes = {
    date: PropTypes.string,
    setLoading: PropTypes.func,
    loading: PropTypes.bool.isRequired,
    setExportFileCsv: PropTypes.func,
}

export default TabelaPreco